import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDetailViewState {
  isDetailViewOpen: boolean;
}

const initialState: IDetailViewState = {
  isDetailViewOpen: false,
};

export const modalAsTabSlice = createSlice({
  name: "detailView",
  initialState,
  reducers: {
    setIsDetailViewOpen: (state, action: PayloadAction<boolean>) => {
      state.isDetailViewOpen = action.payload;
    },
  },
});

export const { setIsDetailViewOpen } = modalAsTabSlice.actions;

export const modalsOpen = modalAsTabSlice.reducer;
